import React, { useMemo } from 'react';

import { IonCol, IonGrid, IonRow } from '@ionic/react';

import get from 'lodash/get';

import { DescriptionItem, DescriptionList } from 'components/DescriptionList';
import { AmountFormatter, DateValueFormatter } from 'intl';
import ApproverListItem from 'scenes/FinancePage/IO/Details/components/Details/components/Approver';
import Status from 'scenes/FinancePage/IO/Details/components/Status';

const General = ({ data }: { data: any }) => {
  const budgets = get(data, 'budget.monthly');

  const isEqualMonthsBudgets = useMemo(() => {
    return budgets?.every(
      (compareMonth: any) =>
        compareMonth.amount.amount === budgets[0].amount.amount // compare for equal months budgets
    );
  }, [budgets]);

  return (
    <DescriptionList data={data}>
      <IonGrid>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'period'}
              label={'Period'}
              type={'dateRange'}
              template={'MONTH'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'status'}
              label={'Status'}
              type={'status'}
              statusFactory={Status}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'businessPartner.name'}
              label={'Business partner'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'owner'}
              label={'Owner'}
              valueParser={({ name, email } = {}) => (
                <>
                  {name}
                  <br />
                  {email && (
                    <a
                      href={`mailto:${email}`}
                      target={'_blank'}
                      rel={'noreferrer'}
                    >
                      {email}
                    </a>
                  )}
                </>
              )}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'affiliates'}
              label={'Affiliates'}
              valueParser={'commaList'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'agreementType.name'}
              label={'Agreement Type'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'budget.total.amount'}
              type={'amount'}
              label={'Total budget'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'budget.revShareBudget.rateOfNet'}
              type={'percent'}
              label={'Rate of Net Rev.'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'budget.total.amount.currencyCode'}
              label={'Currency'}
              className={'ion-text-uppercase'}
            />
          </IonCol>
          <IonCol size={'6'}>
            {isEqualMonthsBudgets ? (
              <DescriptionItem
                label={'Monthly budget'}
                field={'budget.monthly.[0].amount'}
                type={'amount'}
              />
            ) : (
              <DescriptionItem
                label={'Monthly budget'}
                field={'budget.monthly'}
                type={'typographyList'}
                getLabel={({ amount, period }: any) => (
                  <>
                    <DateValueFormatter value={period.from} template={'MMM'} />
                    :&nbsp;
                    <AmountFormatter value={amount} />
                  </>
                )}
              />
            )}
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'paymentTerms.paymentTerms.name'}
              label={'Payment term'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'paymentTerms.expenseType.name'}
              label={'Expense type'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'paymentTerms.trafficRestrictions'}
              label={'Traffic restrictions'}
              valueParser={'commaList'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              field={'paymentTerms.invoiceRequirements'}
              label={'Invoice requirements'}
              valueParser={'commaList'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'} />
          <IonCol size={'6'}>
            <DescriptionItem
              field={'approvers'}
              label={'Approvers'}
              type={'typographyList'}
              item={ApproverListItem}
              placeholder={'-'}
            />
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size={'6'}>
            <DescriptionItem
              label={'Last Updated By'}
              type={'metadata'}
              value={data}
              userField={'metadata.updatedBy'}
              dateField={'metadata.updated'}
            />
          </IonCol>
          <IonCol size={'6'}>
            <DescriptionItem
              label={'Created By'}
              type={'metadata'}
              value={data}
              userField={'metadata.createdBy'}
              dateField={'metadata.created'}
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </DescriptionList>
  );
};

export default General;
